import { AppTheme } from '@/entities/UserSettings';
import UserPreferences from '@/services/UserPreferences';
// ======================================================================================
// Single source of truth for the app theme.
//
// Note: If you change the storage key or the default here, change the inline snippet in
// public/index.html to match - otherwise the flash comes back.
// ======================================================================================
const DARK_MEDIA_QUERY = '(prefers-color-scheme: dark)';
/**
 * An explicit user choice, or null if the user has never toggled the theme.
 */
function storedTheme() {
    try {
        const value = localStorage.getItem(UserPreferences.LocalStorageKeys.Theme.key);
        return value === AppTheme.DARK || value === AppTheme.LIGHT ? value : null;
    }
    catch {
        return null;
    }
}
function systemTheme() {
    const prefersDark = typeof window.matchMedia === 'function' && window.matchMedia(DARK_MEDIA_QUERY).matches;
    return prefersDark ? AppTheme.DARK : AppTheme.LIGHT;
}
export function resolveTheme() {
    return storedTheme() ?? systemTheme();
}
export function applyTheme(theme) {
    const resolved = theme === AppTheme.DARK ? AppTheme.DARK : AppTheme.LIGHT;
    document.documentElement.setAttribute('data-theme', resolved);
    document.documentElement.style.colorScheme = resolved;
}
/** Persist and apply a theme. Use this for user-initiated changes. */
export function setTheme(theme) {
    const resolved = theme === AppTheme.DARK ? AppTheme.DARK : AppTheme.LIGHT;
    try {
        UserPreferences.setPreference(UserPreferences.LocalStorageKeys.Theme, resolved);
    }
    catch { }
    applyTheme(resolved);
}
